var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ion-page"},[_c('ion-header',{attrs:{"translucent":""}},[_c('ion-toolbar',[_c('ion-title',[_vm._v("Uitnodigingen")])],1)],1),_c('ion-content',{attrs:{"fullscreen":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }